import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { first, filter } from 'rxjs/operators';
import { ApiConfiguration, IamAPI } from './api/core';
import { AppConfig, APP_CONFIG } from './app.models';
import { AuthService } from './auth.service';
import { combineLatest } from 'rxjs';
import { loadLoggedInUser } from './users';
import { Store } from '@ngrx/store';

@Component({
    selector: 'liebherr-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    constructor(
        private authService: AuthService,
        private coreApiConfig: ApiConfiguration,
        @Inject(APP_CONFIG) private appConfig: AppConfig,
        private iamAPI: IamAPI,
        private store: Store
    ) {
        // configure generated api module with base url from app config
        this.coreApiConfig.rootUrl = this.appConfig.coreUrl;

        //oauth is configured in app.module

        // creating user if not already there
        combineLatest([this.authService.isAuthenticated$, this.authService.isDoneLoading$])
            .pipe(
                filter(([isAuthenticated, isDoneLoading]) => isAuthenticated === true && isDoneLoading === true),
                first()
            )
            .subscribe(([isAuthenticated, isDoneLoading]) => {
                // console.log('iamAPI', isAuthenticated, isDoneLoading, this.coreApiConfig.rootUrl);
                this.iamAPI.postUser().pipe(first()).subscribe();
                this.store.dispatch(loadLoggedInUser());
            });
    }
}
